import { render } from "./ClearfixContent.vue?vue&type=template&id=467b9a56"
import script from "./ClearfixContent.vue?vue&type=script&lang=js"
export * from "./ClearfixContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__